import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { AuthService } from '@shared/services/auth/auth.service';
import { GlobalSpinnerService } from '@shared/services/global-spinner/global-spinner.service';

export const optionalSessionGuard: CanActivateFn = async (): Promise<boolean> => {
  const authService = inject(AuthService);
  const globalSpinner = inject(GlobalSpinnerService);

  globalSpinner.showSpinner();

  try {
    await authService.ensureSession();
    return true;
  } finally {
    globalSpinner.hideSpinner();
  }
};

export const authenticationGuard: CanActivateFn = async (): Promise<boolean> => {
  const authService = inject(AuthService);
  const globalSpinner = inject(GlobalSpinnerService);

  globalSpinner.showSpinner();

  try {
    const sessionOk = await authService.ensureSession();

    if (sessionOk) {
      globalSpinner.hideSpinner();
      return true;
    }

    authService.startOAuth();
    return false;
  } catch (error) {
    globalSpinner.hideSpinner();
    throw error;
  }
};

export const unauthenticatedGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean => {
  const authService = inject(AuthService);
  const globalSpinner = inject(GlobalSpinnerService);

  if (route.queryParamMap.has('oauth_error')) {
    globalSpinner.hideSpinner();
    return true;
  }

  globalSpinner.showSpinner();
  authService.startOAuth();
  return false;
};
